import React from 'react';
import { useState, useEffect } from 'react';

import SeamlessScene from '../components/common/SeamlessScene';
import Model1 from '../components/common/model';
import './../animations.css'
import hiwicon1 from './../assets/hiwIcon03.svg'
import hiwicon2 from './../assets/hiwIcon02.svg'
import hiwicon3 from './../assets/hiwIcon01.svg'
import logodecor2 from '../assets/decor.svg'
import circle from '../assets/circle1.svg'
import MouseTrailSVG from '../components/common/MouseTrailSVG'
import mandala from '../assets/mandala1.svg'
import frame1 from '../assets/frame2.svg'
import herologo from '../assets/herologo.svg'
import Header from '../components/layout/header';
import Button from '../components/common/button';
import HeadingBlock from '../components/common/heading';
import HowItWorks from '../components/common/hiw';
import HomeS2 from '../sections/homesec1';
import { supabase } from '../supabase';
import FatimaHand from '../components/common/fatimahand';
import Footer from '../components/layout/footer';
import Preloader from '../components/layout/preloader';
import PopUp from '../components/layout/popup';
import './home.css'

const Home = () => {
    return ( <>
    <Preloader />
    <Header />
    <PopUp />
    <SeamlessScene/>
    <main>
    <div className="secBg scalein2 ">
        <img src={frame1} alt=""  />

            </div>
    <div className="secContainer">
        <section className='section1 '>
            
        <div className="heroCont1 homehero">
            <div className="logoicon scaleIn2">
                <FatimaHand />
            </div>
            <div className="logoCont">
                <MouseTrailSVG />
            <img className='homelogo scaleIn3' src={herologo} alt="Egycraft ايجي كرافت" />
            <img className='logodecor2 scaleIn4' src={logodecor2} alt="" />
        </div>
        <h3 className='fadeIn2'>Discover The Craft of Egypt</h3>
        <div className="btnFlex">
            <Button style1="size2 blue" cta="Book my ticket" link="/booking" />
            <Button style1="size2 beige" cta="View Details" link="/exhibitiondetails" />

        </div>
        </div>
    </section>
    </div>
    <div className="secContainer modelCont">
        <div className="heroCont2 ">
            <div className="animatedCircleCont">
            <div className="rectangle1"></div>
                <img src={circle} alt="" />
            </div>
            <Model1 />
        </div>
    </div>
    <div className="secContainer sec2Cont scrollAnimate2">
       <HomeS2 />
    </div>
       <div className="secContainer sec3Cont fadeIn5">
     <section className='section2 section3'>
<div className="mandalaCont">
        <img className='mandala homeMandala' src={mandala} alt="" />
</div>
        <div className="rightBlock">
        <HeadingBlock 
        style1="light left"
        heading="How It works" />
        <div className="hiwFlex">
        <HowItWorks
        icon ={hiwicon1}
        number="1"
        title="Browse our vendors and categories"
        desc="Explore upcoming and current Vendors across Egypt. Filter by location, date, and craft category to find events that match your interests."
        />
        <HowItWorks
        icon ={hiwicon2}
        number="2"
        title="Book Your Tickets"
        desc="Explore upcoming and current Vendors across Egypt. Filter by location, date, and craft category to find events that match your interests."
        />
        <HowItWorks
        icon ={hiwicon3}
        number="3"
        title="Attend the event seamlessly"
        desc="Explore upcoming and current Vendors across Egypt. Filter by location, date, and craft category to find events that match your interests."
        />
        </div>
        </div>
    </section>
   </div>
    </main>
    <Footer />

    </> );
}
 
export default Home;